import { translateFormatter } from '@manomano-internal/i18n/esm/placeholders';
export const loyaltyCashbackPerentageLabel = translateFormatter<{
  cashbackPercentage: number;
}>("+{cashbackPercentage}% cagnott\xE9s", undefined, undefined, "en");